import { render } from "./trainDetail.vue?vue&type=template&id=4afc011d&scoped=true"
import script from "./trainDetail.vue?vue&type=script&lang=js"
export * from "./trainDetail.vue?vue&type=script&lang=js"

import "./trainDetail.vue?vue&type=style&index=0&id=4afc011d&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afc011d"]])

export default __exports__